var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},_vm._l((_vm.docs),function(misc){return _c('misc-tile',{key:misc._id,attrs:{"misc":misc}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }